import React, { useEffect, useState } from "react";
import MealInfo from "../components/model/MealInfo";

const Meals = ({ meals }) => {
  const getAllMeals = meals.meals;
  const currencySymbol = meals.currency_symbol;
  const [isMealOpen, setIsMealOpen] = useState(false);
  const [selectedMealId, setSelectedMealId] = useState(null);
  const [selectedMeal, setSelectedMeal] = useState(null);
  const handleMealClick = (meal) => {
    setSelectedMealId(meal.meal_id);
    // console.log("The meal id is:", meal.meal_id);

    // Find the selected meal object from meals array
    const selected = getAllMeals.find((m) => m.meal_id === meal.meal_id);
    setSelectedMeal(selected);

    // console.log("The selected meal data is:", selected);
    setIsMealOpen(true);
  };
  const dayLabels = {
    monday: "M",
    tuesday: "Tu",
    wednesday: "W",
    thursday: "Th",
    friday: "F",
    saturday: "Sa",
    sunday: "Su",
  };

  // useEffect(() => {
  //   console.log("the data is :", currencySymbol);
  // }, []);

  return (
    <>
      <div className="flex flex-col max-w-7xl mx-auto mt-8 p-4">
        <h1 className="text-2xl sm:text-3xl font-bold mb-6 text-start font-outfit">
          Meals Available
        </h1>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-5 gap-6 mx-auto justify-items-center">
          {Array.isArray(getAllMeals) && getAllMeals.length > 0 ? (
            getAllMeals.map((meal, index) => (
              <div
                key={index}
                className="flex flex-col  overflow-hidden cursor-pointer"
                onClick={() => handleMealClick(meal)}
              >
                <div className="w-full aspect-square rounded-xl overflow-hidden">
                  <img
                    src={meal.meal_cover_image}
                    alt={meal.meal_name}
                    className="w-full h-full  xl:w-64 xl:h-64 object-cover aspect-square rounded-xl"
                  />
                </div>
                <div className="p-1 flex flex-col gap-2">
                  <h2 className="text-base md:text-lg lg:text-xl  mt-4 xl:mt-0 font-semibold text-gray-800 font-outfit leading-relaxed line-clamp-1">
                    {meal.meal_name}
                  </h2>
                  <p className="text-[#FF6943] font-bold text-sm sm:text-base md:text-lg">
                    {currencySymbol || "$"}{" "}
                    {Number(meal.trial_serving_cost).toFixed(2)}{" "}
                    <span className="text-orange font-normal text-xs">
                      / Meal
                    </span>
                  </p>

                  {/* Days */}

                  <div className="flex gap-1 mb-1">
                    {meal.availability_data.map((day) => {
                      const base =
                        "relative w-[18px] h-[18px] md:w-6 md:h-6 text-[12px] font-medium rounded-md flex items-center justify-center overflow-hidden";

                      if (day.isLunch && day.isDinner) {
                        return (
                          <span
                            key={day.key}
                            className={`${base} bg-[#B472FF] text-white
            after:content-['']
            after:absolute
            after:inset-0
            after:rounded-md
            after:bg-[#FF6943]
            after:[clip-path:polygon(100%_0,100%_100%,0_100%)]
          `}
                            title="Lunch + Dinner"
                          >
                            {/* TEXT LAYER */}
                            <span className="relative z-10">
                              {dayLabels[day.key]}
                            </span>
                          </span>
                        );
                      }

                      // 🟣 Lunch
                      if (day.isLunch) {
                        return (
                          <span
                            key={day.key}
                            className={`${base} bg-[#B472FF] text-white`}
                            title="Lunch"
                          >
                            {dayLabels[day.key]}
                          </span>
                        );
                      }

                      // 🟠 Dinner
                      if (day.isDinner) {
                        return (
                          <span
                            key={day.key}
                            className={`${base} bg-[#FF6943] text-white`}
                            title="Dinner"
                          >
                            {dayLabels[day.key]}
                          </span>
                        );
                      }

                      // ⚪ None
                      return (
                        <span
                          key={day.key}
                          className={`${base} bg-gray-100 text-[#303030]`}
                          title="Not available"
                        >
                          {dayLabels[day.key]}
                        </span>
                      );
                    })}
                  </div>

                  {/* Lunch/Dinner dots */}
                  <div className="flex items-center gap-4 mb-1">
                    {meal.availability_data.some((d) => d.isLunch) && (
                      <div className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-[#B472FF]"></span>
                        <span className="text-xs sm:text-sm text-gray-800">
                          Lunch
                        </span>
                      </div>
                    )}
                    {meal.availability_data.some((d) => d.isDinner) && (
                      <div className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-[#FF6943]"></span>
                        <span className="text-xs sm:text-sm text-gray-800">
                          Dinner
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Description */}
                  <p
                    className="
    text-[#6D6D6D] 
    text-xs sm:text-sm md:text-sm lg:text-base 
    leading-snug 
    break-words 
    leading-relaxed line-clamp-2 text-ellipsis
    w-full 
    max-w-[100px] sm:max-w-[100px] md:max-w-[200px] lg:max-w-[200px] xl:max-w-[200px]
    whitespace-normal
  "
                  >
                    {meal.meal_description}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p>No meals found</p>
          )}
        </div>
      </div>

      {isMealOpen && selectedMealId && (
        <MealInfo
          meals={selectedMeal}
          currecy={currencySymbol}
          onClose={() => setIsMealOpen(false)}
        />
      )}
    </>
  );
};

export default Meals;
